module.exports = __webpack_public_path__ + "assets/img/black_l2oops_mini.23622e66.png";